import { useEffect, useRef, useState } from 'react';
import serviceImage1 from '@/assets/services/service-01.jpg';
import serviceImage2 from '@/assets/services/service-02.jpg';
import serviceImage3 from '@/assets/services/service-03.jpg';
import serviceImage4 from '@/assets/services/service-04.jpg';

export default function ServicesSection() {
  const services = [
    {
      number: '01',
      title: 'Металлоконструкции под заказ',
      description: 'Изготовление высококачественных металлических конструкций, изделий и их частей для строительных проектов любой сложности. Современное оборудование и опытные специалисты гарантируют надежность и долговечность продукции.',
      image: serviceImage1
    },
    {
      number: '02',
      title: 'Рекламное продвижение',
      description: 'Комплексные рекламные решения для продвижения вашего бизнеса. Разработка креативных концепций, медиапланирование, организация рекламных кампаний и анализ их эффективности для достижения максимальных результатов.',
      image: serviceImage2
    },
    {
      number: '03',
      title: 'Дизайн и айдентика',
      description: 'Профессиональные дизайнерские услуги для создания уникального визуального образа вашего бренда. От графического дизайна до разработки фирменного стиля, мы воплощаем ваши идеи в жизнь с вниманием к каждой детали.',
      image: serviceImage3
    },
    {
      number: '04',
      title: 'Фотосъемка для бизнеса',
      description: 'Профессиональная фотосъемка для бизнеса и личных проектов. Коммерческая, рекламная, предметная и портретная фотография высочайшего качества. Создаем визуальный контент, который привлекает внимание и передает вашу историю.',
      image: serviceImage4
    }
  ];

  const [visibleItems, setVisibleItems] = useState<number[]>([]);
  const cardsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.getAttribute('data-index'));
          if (entry.isIntersecting) {
            setVisibleItems((prev) =>
              prev.includes(index) ? prev : [...prev, index]
            );
          }
        });
      },
      {
        threshold: 0.25,
        rootMargin: '0px 0px -10% 0px'
      }
    );

    cardsRef.current.forEach((card) => {
      if (card) {
        observer.observe(card);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-900 mb-4">
            Наши Услуги
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const isVisible = visibleItems.includes(index);
            return (
              <div
                key={index}
                data-index={index}
                ref={(el) => {
                  cardsRef.current[index] = el;
                }}
                className={`bg-white rounded-lg overflow-hidden shadow-sm transition-all duration-700 ease-out ${
                  isVisible
                    ? 'opacity-100 translate-y-0 shadow-lg'
                    : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 120}ms` }}
              >
              <div className="w-full h-64 relative">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-6 left-6 text-6xl font-light text-white/90">
                  {service.number}
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-medium text-gray-900 mb-4">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 font-light leading-relaxed">
                  {service.description}
                </p>
              </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
